// Generated by Melange

import MediaLinksModuleCss from "./mediaLinks.module.css";
import * as ReactSimpleIcons from "@icons-pack/react-simple-icons";
import * as Curry from "melange.js/curry.jsx";
import * as SimpleIcons from "../simpleIcons/simpleIcons.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = MediaLinksModuleCss;

function MediaLinks(Props) {
  let lastFmUrl = Props.lastFmUrl;
  let musicBrainzUrl = Props.musicBrainzUrl;
  let skeleton = Props.skeleton;
  const links = [];
  Stdlib__Option.iter((function (lastFmUrl) {
    links.push({
      color: ReactSimpleIcons.SiLastdotfmHex,
      icon: JsxRuntime.jsx(ReactSimpleIcons.SiLastdotfm, Curry._3(SimpleIcons.Lastdotfm.makeProps, undefined, undefined, undefined)),
      label: "Last.fm",
      url: lastFmUrl
    });
  }), lastFmUrl);
  Stdlib__Option.iter((function (musicBrainzUrl) {
    links.push({
      color: ReactSimpleIcons.SiMusicbrainzHex,
      icon: JsxRuntime.jsx(ReactSimpleIcons.SiMusicbrainz, Curry._3(SimpleIcons.Musicbrainz.makeProps, undefined, undefined, undefined)),
      label: "MusicBrainz",
      url: musicBrainzUrl
    });
  }), musicBrainzUrl);
  if (Stdlib__Option.value(skeleton, false) || links.length === 0) {
    return null;
  } else {
    return JsxRuntime.jsx("nav", {
      children: links.map(function (link) {
        const Key = link.url;
        return JsxRuntime.jsxs("a", {
          children: [
            React.cloneElement(link.icon, {
              "aria-hidden": true,
              style: {
                color: link.color
              }
            }),
            JsxRuntime.jsx("span", {
              children: link.label
            })
          ],
          className: css.item,
          href: link.url,
          rel: "noopener",
          target: "_blank"
        }, Key);
      }),
      className: css.root
    });
  }
}

const make = MediaLinks;

export {
  make,
}
/* css Not a pure module */
